export default "__VITE_ASSET__CLwuBtCR__"